import { EM_THREADS } from './mockData';
import type { EmailHeaderStats } from './types';

export { emInitials, emSummary, emThreadInFolder } from './mockData';

export function emNormLang(raw?: string | null): string {
  const v = (raw ?? '').trim().toLowerCase();
  if (!v || v === 'en' || v === 'eng' || v === 'english') return 'en';
  return v;
}

export function emIsNonEnglish(raw?: string | null): boolean {
  return emNormLang(raw) !== 'en';
}

export function emLangLabel(raw?: string | null): string {
  const code = emNormLang(raw);
  if (code === 'en') return 'English';
  if (code === 'es') return 'Spanish';
  if (code === 'fr') return 'French';
  return code.toUpperCase();
}

export function threadHasInboundPatientMessages(thread: {
  messages: Array<{ who: string }>;
}): boolean {
  return thread.messages.some((message) => message.who === 'patient');
}

export function threadNeedsTranslation(thread: {
  lang?: string;
  detectedLang?: string;
  messages: Array<{ who: string; translated?: boolean; lang?: string }>;
}): boolean {
  if (threadHasStoredTranslation(thread)) return true;
  if (emIsNonEnglish(thread.detectedLang ?? thread.lang)) return true;
  if (
    thread.messages.some(
      (message) => message.who === 'patient' && emIsNonEnglish(message.lang),
    )
  ) {
    return true;
  }
  // Language is detected on POST /translate — show the button for any inbound patient mail.
  return threadHasInboundPatientMessages(thread);
}

export function threadHasStoredTranslation(thread: {
  translated?: boolean;
  messages: Array<{ bodyTr?: string; translated?: boolean }>;
}): boolean {
  if (thread.translated) return true;
  return thread.messages.some((message) => Boolean(message.bodyTr?.trim()));
}

export function emailHeaderStats(): EmailHeaderStats {
  return {
    total: EM_THREADS.length,
    unread: EM_THREADS.filter((t) => t.unread).length,
    needsMe: EM_THREADS.filter(
      (t) => t.replyState === 'drafted' || ['drafted', 'drafted_low_conf', 'held'].includes(t.aiState),
    ).length,
    emergency: EM_THREADS.filter((t) => t.tags.includes('emergency')).length,
  };
}
